import React, { useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons'

const PayDataText: React.FC = () => {
  const [showCalculationText, setShowCalculationText] = useState(false)
  const [showInfoText, setShowInfoText] = useState(false)

  return (
    <div className="w-full p-4-t mb-4 flex flex-col justify-start items-start gap-4">
      <h2>Rapportera årslönesummor för {new Date().getFullYear() - 1}</h2>
      <div>
        <p>Här fyller du i och lämnar in årlönesummorna för året.</p>
        <p>
          Har du några frågor? Vänligen kontakta{' '}
          <span className="font-bold">Ekonomi@fastigo.se</span>
        </p>
      </div>
      <div className="flex flex-col w-full items-start gap-4">
        <button
          onClick={() => setShowInfoText(!showInfoText)}
          className="text-darkBlue md:pr-12 text-green font-bold flex flex-row gap-2 items-center"
        >
          Varför behöver jag lämna in uppgifterna?
          {showInfoText ? (
            <FontAwesomeIcon icon={faChevronUp} />
          ) : (
            <FontAwesomeIcon icon={faChevronDown} />
          )}
        </button>
        {showInfoText && (
          <div>
            <p className="p-small">
              Årsrapporteringen är underlag för den årliga medlemsavgiften (framgår av Fastigos
              stadgar §3). Medlemsavgiften faktureras under januari månad och ska vara betald senast
              vid februari månads utgång. Uppsägning av medlemskap Enligt Fastigos stadgar §22
              upphör medlemskapet vid det årsskifte som inträder närmast efter 6 månader efter
              skriftlig uppsägning. Detta innebär att om uppsägning gjorts under tiden 2025-07-01 –
              2026-06-30 upphör medlemskapet i Fastigo 2026-12-31.
            </p>
          </div>
        )}
        <button
          className="text-darkBlue md:pr-12 text-green font-bold flex flex-row gap-2 items-center"
          onClick={() => setShowCalculationText(!showCalculationText)}
        >
          Hur beräknas årsavgiften till Fastigo?
          {showCalculationText ? (
            <FontAwesomeIcon icon={faChevronUp} />
          ) : (
            <FontAwesomeIcon icon={faChevronDown} />
          )}
        </button>
        {showCalculationText && (
          <div>
            <p className="p-small">
              Medlemsavgiften till Fastigo är 1000 kronor, den är inte avdragsgill. Därtill
              tillkommer en serviceavgift om 0,25% av föregående års totala lönesumma dock minst 10%
              av gällande prisbasbelopp. Serviceavgiften är avdragsgill. Avgiften till
              Trygghetsfonden Fastigo-LO (TFL) är 0,15% av de kollektivanställdas totala lönesumma,
              dock minst 100 kronor. Avgiften till Trygghetsrådet Fastigo (TRF) är 0,15% av
              tjänstemännens totala lönesumma exklusive VD, dock minst 100 kronor. Avgiften till
              stiftelsen måleriutveckling är 1,1 % på lönesumma för arbetstagare som omfattas av
              Månadslöneavtalet måleri, gäller ej målare som omfattas av Kollektivavtalet för
              måleriyrket (ackordsavtalet).
            </p>
            <br></br>
            <p className="p-small">
              {' '}
              - Beloppet är samma uppgift som du lämnat till Skatteverket som underlag för
              arbetsgivaravgift, styrelse- och revisionsarvoden undantagna.{' '}
            </p>
            <p className="p-small">
              - Beloppet ska inkludera lönesumma för all personal som arbetat under året, oavsett om
              vissa personer endast arbetat delar av året.
            </p>
            <p className="p-small">
              {' '}
              - Inkluderar värdet av förmåner, exempelvis fri kost, bostad och bilförmån.{' '}
            </p>
            <p className="p-small">
              {' '}
              - Även personal som företaget uppbär ersättning för, från exempelvis
              Försäkringskassan, ska ingå.
            </p>
          </div>
        )}
      </div>
    </div>
  )
}

export default PayDataText
